import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { EMPTY, Observable } from 'rxjs';
import { buildUpdateUser } from 'src/app/data/factory/user.factory';
import { HelpDialog } from 'src/app/data/models/dto/help-dialog.dto';
import { LinkYearsClassrooms } from 'src/app/data/models/dto/link-years-classrooms';
import { ActivesoftIntegration } from 'src/app/data/models/interfaces/activesoft-integration.interface';
import { ActivesoftIntegrationService } from 'src/app/data/services/activesoft-integration.service';
import { ClassRoomsService } from 'src/app/data/services/classroom.service';
import { HelpDialogComponent } from 'src/app/ui/components/help-dialog/help-dialog.component';
import { Child } from '../../../../../data/models/interfaces/child.interface';
import { Profile } from '../../../../../data/models/interfaces/profile.interface';
import { TreeNode } from '../../../../../data/models/interfaces/tree-node.interface';
import { User } from '../../../../../data/models/interfaces/user.interface';
import { ChildService } from '../../../../../data/services/child.service';
import { TreeSegmentsService } from '../../../../../data/services/tree-services/tree-segments.service';
import { UsersService } from '../../../../../data/services/user.service';
import { SelectedUserUtil } from '../../../../../data/utils/selected-user.utils';
import { HelpUserProfilesDialogComponent } from '../../../../components/help-user-profiles-dialog/help-user-profiles-dialog.component';
import { genericDialog } from '../../../../../data/utils/generic-dialog.utils';
import { GenericDialogDto } from '../../../../../data/models/dto/generic-dialog.dto';
import { UserUtil } from '../../../../../data/utils/user.utils';
import { UserParamsDto } from '../../../../../data/models/dto/user-params.dto';
import { ClassroomFilterDto } from '../../../../../data/models/dto/classroom-filter.dto';
import { CustomSnackbarService } from '../../../../../ui/components/custom-snackbar/custom-snackbar-service';
import { SnackbarTypeEnum } from '../../../../../data/models/enum/snackbar-type.enum';
import { Credentials } from '../../../../../data/models/enum/credentials.enum';
import { ActivesoftIntegrationUtil } from '../../../../../data/utils/activesoft-integration.utils';

@Component({
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.scss'],
})
export class UserFormComponent implements OnInit {
  userData: any;
  hide = true;
  snackbarDuration: number = 3500;

  constructor(
    private fb: FormBuilder,
    private actRoute: ActivatedRoute,
    private userService: UsersService,
    private userUtil: UserUtil,
    private childService: ChildService,
    private selectedUser: SelectedUserUtil,
    private readonly treeSegmentsService: TreeSegmentsService,
    public dialog: MatDialog,
    private cookieService: CookieService,
    private classRoomsService: ClassRoomsService,
    private readonly activesoftIntegrationService: ActivesoftIntegrationService,
    private snackbarService: CustomSnackbarService,
    private readonly activesoftIntegrationUtil: ActivesoftIntegrationUtil
  ) {}

  userForm: FormGroup = this.fb.group({
    profile: ['', [Validators.required]],
    ra: ['', []],
    idActivesoft: ['', []],
    name: ['', [Validators.required]],
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required]],
    idsClassRooms: ['', [Validators.required, Validators.minLength(1)]],
    phone: ['', []],
  });

  yearClassroomsButtonLabel = 'Adicione uma ou mais turmas';

  prefixIdActivesoft: string = '';
  hasActiveSoftIntegration = true;
  isResponsible = false;
  showBasicFields = false;
  showStudentElements = false;
  profiles: Profile[] = [];
  alertMessage: string = '';
  idsClassRooms: string[] | undefined = [];

  isButtonSegments: boolean = false;
  selectedClassrooms: string = this.yearClassroomsButtonLabel;
  textYear: string = '';
  checkedIdsClassrooms: string[] = [];

  addUsersTo: User[] = [];
  usersToremove: string[] = [];
  addMessageUserProfile: string = '';
  selecteduser: string = '';
  users!: Observable<User[]>;
  classRoomsToAdd: string[] = [];
  classRoomsFromChild: string[] = [];
  user: User | undefined;

  //tree
  treeSegments: TreeNode | undefined;
  treeSegmentsSelected: boolean = false;
  segmentsDefaultText: string = 'Escolha a turma do Aluno';
  segmentsSelectedText: string = this.segmentsDefaultText;

  //gerir a lista de turmas por ano do aluno se for o caso
  classRoomsIdByYear = new Map<string, string[]>();
  classRoomsSortByYear!: Map<string, string[]>;

  dialogInfo: GenericDialogDto = {
    imageUrl: 'assets/images/undraw_personal_info_re_ur1n.svg',
    primaryText: 'Você tem certeza que deseja ver os detalhes desta pessoa?',
    secondaryText:
      'Você será direcionado para uma outra página. Sendo assim, toda informação não salva será perdida. Deseja continuar?',
    btnCancelText: 'Não, cancelar',
    btnConfirmText: 'Sim, continuar',
  };

  idsSchool?: string[];
  invalidMinPasswordErrorMessage?: string;

  async ngOnInit(): Promise<void> {
    this.idsSchool = this.userUtil.getSchools().map((school) => school.id);
    this.userData = this.actRoute.snapshot.data;
    this.profiles = this.userData.userData;

    this.handleProfileEventChange();

    this.user = this.selectedUser.getSelectedUser();

    if (this.user) {
      let profile = this.profiles.find(
        (p) => p.id === this.user?.idsProfiles[0]
      );
      if (profile?.name == 'Aluno') {
        let child = await this.childService.getById(this.user.id).toPromise();
        this.userForm.get('ra')?.setValue(child.ra, { onlySelf: true });
        this.idsClassRooms = child.idsClassRooms;
        this.checkedIdsClassrooms = child.idsClassRooms!;
        await this.loadStudentClassroomsByYear(child.idsClassRooms);
        this.textYear = this.classRoomsSort(this.classRoomsIdByYear) ?? '';
        this.loadSegmentTree(this.textYear);
      }
      this.userForm.get('profile')?.setValue(profile, { onlySelf: true });
      this.userForm
        .get('name')
        ?.setValue(`${this.user.firstName} ${this.user.lastName}`, {
          onlySelf: true,
        });
      this.userForm.get('email')?.setValue(this.user.email, { onlySelf: true });
      this.userForm.get('password')?.setValue('      ', { onlySelf: true });

      this.userForm.get('phone')?.setValue(this.user.phone, { onlySelf: true });

      this.loadChildsForParent();
      this.loadActivesoftIntegration();
    }
    const activesoft = this.cookieService.get('activesoft');
    this.hasActiveSoftIntegration = activesoft == 'yes';
  }

  get canEdit() {
    return !this.user?.integration;
  }

  private classRoomsSort(classRoomsIdByYear: Map<string, string[]>) {
    this.classRoomsSortByYear = new Map(
      [...classRoomsIdByYear].sort((a, b) => +b[0] - +a[0])
    );
    return this.classRoomsSortByYear.keys().next().value;
  }

  private loadClassroomData = async (id: string) => {
    let cRoom = await this.classRoomsService.getById(id).toPromise();
    this.updateClassroomByYear(cRoom.year, [id]);
  };

  private async loadStudentClassroomsByYear(classroomId?: string[]) {
    let promises: any[] = [];

    classroomId?.forEach((id) => {
      promises.push(this.loadClassroomData(id));
    });

    await Promise.all(promises);
  }

  private updateClassroomByYear(
    year: string,
    ids: string[],
    preserveOriginal: boolean = true
  ) {
    let yearKey = this.classRoomsIdByYear.has(year);
    if (!yearKey) {
      this.classRoomsIdByYear.set(year, ids);
    } else {
      let listIds = this.classRoomsIdByYear.get(year);
      if (listIds && preserveOriginal) {
        listIds.push(...ids);
      } else {
        listIds = ids;
      }
      this.classRoomsIdByYear.set(year, listIds);
    }

    let allIds: string[] = [];
    for (let val of this.classRoomsIdByYear.values()) {
      allIds.push(...val);
    }
    if (!preserveOriginal) {
      this.checkedIdsClassrooms = allIds.filter(
        (v, i) => allIds.indexOf(v) === i
      );
    }
  }

  handleProfileEventChange() {
    this.userForm.get('profile')?.valueChanges.subscribe((profile) => {
      if (!profile) {
        this.showBasicFields = false;
        return;
      }
      this.showBasicFields = true;
      this.showStudentElements = profile?.name === 'Aluno';
      this.isResponsible = profile?.name.substring(0, 11) === 'Responsável';
      this.prefixIdActivesoft = '';
      if (profile.name === 'Aluno') {
        this.prefixIdActivesoft = 'A';
        this.userForm.get('ra')?.setValidators([Validators.required]);
        this.addMessageUserProfile = 'responsável';
        this.alertMessage =
          'Caso o perfil do responsável não esteja cadastrado no sistema, você pode incluir depois esse vínculo.';
      } else {
        if (this.isResponsible) {
          this.prefixIdActivesoft = 'R';
        }
        this.userForm.get('ra')?.clearValidators();
        this.addMessageUserProfile = 'filho';
        this.alertMessage =
          'Caso o perfil do filho não esteja cadastrado no sistema, você pode incluir depois esse vínculo.';
      }
      this.userForm.get('ra')?.updateValueAndValidity();
      this.userForm.get('idsClassRooms')?.updateValueAndValidity();
      this.users = EMPTY;
      this.addUsersTo = [];
      this.selecteduser = '';

      if (this.showStudentElements) {
        this.createTreeSegments();
      } else {
        //para tratar obrigatoriedade do campo
        this.userForm
          .get('idsClassRooms')
          ?.setValue(['dummy'], { onlySelf: true });
      }
      this.resetPasswordValidator();
    });
  }

  private async loadSegmentTree(year: string): Promise<void> {
    const filter: ClassroomFilterDto = {
      year: year,
      idSchool: this.idsSchool![0],
    };
    const tree = await this.classRoomsService.getTree(filter).toPromise();
    let classrooms = '';
    tree.forEach((segment) => {
      segment.series?.forEach((serie) => {
        serie.classRooms?.forEach((classroom) => {
          if (this.checkedIdsClassrooms!.includes(classroom.id!)) {
            if (classrooms === '') classrooms += classroom.name;
            else classrooms += ', ' + classroom.name;
          }
        });
      });
    });
    this.selectedClassrooms = classrooms;
  }

  updateCheckedClassroom(tree: LinkYearsClassrooms) {
    this.selectedClassrooms = tree.classrooms
      ? tree.classrooms
      : this.yearClassroomsButtonLabel;
    this.textYear = tree.year;
    this.idsClassRooms = tree.idsClassrooms;
    this.checkedIdsClassrooms = tree.idsClassrooms;
    this.userForm.value.idsClassRooms = tree.idsClassrooms;
    this.userForm
      .get('idsClassRooms')
      ?.setValue(
        tree.idsClassrooms && tree.idsClassrooms.length > 0
          ? tree.idsClassrooms
          : undefined,
        { onlySelf: true }
      );

    this.updateClassroomByYear(tree.year, tree.idsClassrooms, false);
    this.userForm.get('idsClassRooms')?.updateValueAndValidity();
    this.userForm.markAsDirty();
    this.isButtonSegments = true;
  }

  addUserTo(option: User) {
    let contain = this.addUsersTo.some((value) => value.email === option.email);
    if (!contain) this.addUsersTo.push(option);
    const index = this.usersToremove.indexOf(option.id);
    if (index > -1) this.usersToremove.splice(index, 1);
    this.userForm.markAsDirty();
  }

  removeUserFromList(usr: User) {
    if (usr.id) this.usersToremove.push(usr.id);
    const index = this.addUsersTo.indexOf(usr);
    if (index > -1) {
      this.addUsersTo.splice(index, 1);
    }
    this.userForm.markAsDirty();
  }

  clearInputFields() {
    this.addUsersTo = [];
    this.userForm.reset();
    this.showStudentElements = false;
  }

  private addRaToChild(user: User) {
    let child = user as Child;
    child.ra = this.userForm.get('ra')?.value;
    return child;
  }

  private addClassRoomsToChild(user: User) {
    let child = user as Child;
    //adiciona/atualiza as classes ao aluno
    child.idsClassRooms = this.checkedIdsClassrooms;
    return child;
  }

  private addParentsToChild(user: User) {
    let child = user as Child;
    //adiciona/atualiza parents para aluno
    if (this.addUsersTo && this.addUsersTo.length > 0) {
      child.parents = this.addUsersTo.map((u) => u.id);
    } else {
      child.parents = [];
    }

    return child;
  }

  private addChildsToParent(user: User) {
    this.addUsersTo.forEach(async (child) => {
      let cld = await this.childService.getById(child.id).toPromise();
      const index = cld.parents?.indexOf(user.id);
      if (index && index == -1)
        await this.childService.addParent(child.id, user.id).toPromise();
    });
  }

  private removeChildFromParent(user: User) {
    this.usersToremove.forEach(async (item) => {
      await this.childService.removeParent(item, user.id).toPromise();
    });
  }

  private paramSnackbar(message: string, type: SnackbarTypeEnum) {
    this.snackbarService.open(message, type, 'center', 'bottom');
  }

  openSnackbar(status: string, customMessage?: string) {
    switch (status) {
      case 'successCreate':
        this.paramSnackbar(
          'Cadastro de usuário realizado com sucesso',
          SnackbarTypeEnum.SUCCESS
        );
        break;
      case 'successUpdate':
        this.paramSnackbar('Atualizado com sucesso', SnackbarTypeEnum.SUCCESS);
        break;
      case 'errorCreate':
        this.paramSnackbar('Erro ao executar operação', SnackbarTypeEnum.ERROR);
        break;
      case 'errorUpdate':
        this.paramSnackbar('Falha ao atualizar', SnackbarTypeEnum.ERROR);
        break;
      case 'warn':
        this.paramSnackbar(customMessage ?? 'Alerta', SnackbarTypeEnum.WARNING);
        break;
    }
  }

  createUser(user: User) {
    if (this.showStudentElements) {
      //create child
      let child = this.addClassRoomsToChild(user);
      child.active = false;
      child = this.addParentsToChild(child);
      child = this.addRaToChild(child);
      this.childService
        .create(child)
        .toPromise()
        .then(() => {
          this.openSnackbar('successCreate');
          this.resetView();
        })
        .catch((ex) => {
          const invalidMinimumPassword: boolean =
            ex?.status === 400 &&
            ex?.error?.data?.type ===
              Credentials.INVALID_MINIMUM_CHARACTERS_PASSWORD &&
            ex?.error?.data?.minimum;

          if (invalidMinimumPassword) {
            this.invalidateMinimumPassword(ex?.error?.data?.minimum);
          } else {
            this.handleError(ex?.error?.data?.message, 'errorCreate');
          }
        });
    } else {
      //create user
      this.userService
        .create(user)
        .toPromise()
        .then((user) => {
          this.saveActiveSoftIntegration(user.id);
          this.addChildsToParent(user);
          this.openSnackbar('successCreate');
          this.resetView();
        })
        .catch((ex) => {
          const invalidMinimumPassword: boolean =
            ex?.status === 400 &&
            ex?.error?.data?.type ===
              Credentials.INVALID_MINIMUM_CHARACTERS_PASSWORD &&
            ex?.error?.data?.minimum != null;

          if (invalidMinimumPassword) {
            this.invalidateMinimumPassword(ex?.error?.data?.minimum);
          } else {
            this.handleError(ex?.error?.data?.message, 'errorCreate');
          }
        });
    }
  }

  private formatEmailExistErroMessage(text: string) {
    //check error for child
    const errorText = 'User child Already Exists!';
    const isTextPresent = text.includes(errorText);
    if (isTextPresent) {
      return 'E-mail ja cadastrado';
    }
    //check error for other users
    const regex = /user already exist with email: ([^\s@]+@[^\s@]+\.[^\s@]+)/;
    const match = text.match(regex);
    return match ? `E-mail ${match[1]} já cadastrado` : undefined;
  }

  editUser(user: User) {
    if (user) {
      if (this.showStudentElements) {
        //edit child
        let child = this.addClassRoomsToChild(user);
        child = this.addParentsToChild(child);
        child = this.addRaToChild(child);
        this.childService
          .update(child)
          .toPromise()
          .then(() => {
            this.openSnackbar('successUpdate');
            this.resetView();
            this.user = undefined;
          })
          .catch((ex) => {
            const invalidMinimumPassword: boolean =
              ex?.status === 400 &&
              ex?.error?.data?.type ===
                Credentials.INVALID_MINIMUM_CHARACTERS_PASSWORD &&
              ex?.error?.data?.minimum != null;

            if (invalidMinimumPassword) {
              this.invalidateMinimumPassword(ex?.error?.data?.minimum);
            } else {
              this.handleError(ex?.error?.data?.message, 'errorUpdate');
            }
          });
      } else {
        //edit user
        this.userService.getById(user.id).subscribe((response) => {
          let userUpdated = buildUpdateUser(response, user);
          this.userService
            .update(userUpdated)
            .toPromise()
            .then(() => {
              this.saveActiveSoftIntegration(user.id);
              this.removeChildFromParent(user);
              //add childs to user
              this.addChildsToParent(user);
              this.openSnackbar('successUpdate');
              this.resetView();
              this.user = undefined;
            })
            .catch((ex) => {
              const invalidMinimumPassword: boolean =
                ex?.status === 400 &&
                ex?.error?.data?.type ===
                  Credentials.INVALID_MINIMUM_CHARACTERS_PASSWORD &&
                ex?.error?.data?.minimum != null;

              if (invalidMinimumPassword) {
                this.invalidateMinimumPassword(ex?.error?.data?.minimum);
              } else {
                this.handleError(ex?.error?.data?.message, 'errorUpdate');
              }
            });
        });
      }
    }
  }

  saveUser() {
    let user = this.populateUser();
    if (this.user) {
      user.id = this.user.id;
      user.active = this.user.active;
      user.dtCreated = this.user.dtCreated;
      this.editUser(user);
    } else {
      this.createUser(user);
    }
  }

  saveActiveSoftIntegration(idUser: string) {
    if (this.isResponsible && this.hasActiveSoftIntegration) {
      let activesoft = {
        idUser: idUser,
        idIntegration: `${this.prefixIdActivesoft}${
          this.userForm.get('idActivesoft')?.value
        }`,
      } as ActivesoftIntegration;

      this.activesoftIntegrationService.createOrUpdate(activesoft).toPromise();
    }
  }

  handleSearchUser() {
    if (this.selecteduser && this.selecteduser.length > 3) {
      if (this.showStudentElements) {
        this.findUsers(this.selecteduser);
      } else {
        this.findChilds(this.selecteduser);
      }
    }
  }

  private findUsers(text: string) {
    const filter: UserParamsDto = {
      idsSchool: this.idsSchool,
      name: text,
    };
    this.users = this.userService.getByName(filter);
  }

  private findChilds(text: string) {
    this.users = this.childService.findByName(text, this.idsSchool![0]);
  }

  async loadChildsForParent() {
    if (this.user) {
      if (this.showStudentElements) {
        const child = await this.childService.getById(this.user.id).toPromise();
        if (child.parents) {
          child.parents.forEach(async (c) => {
            let usr = await this.userService.getById(c).toPromise();
            this.addUsersTo.push(usr);
          });
        }
        if (child.idsClassRooms) {
          this.classRoomsFromChild = child.idsClassRooms;
        }
        this.createTreeSegments();

        this.userForm.get('idsClassRooms')?.setValue(child.idsClassRooms);
      } else {
        this.addUsersTo = await this.childService
          .findByParent(this.user?.id)
          .toPromise()
          .catch((err) => {
            return [];
          });
      }
    }
  }

  async loadActivesoftIntegration() {
    if (this.user) {
      if (this.isResponsible && this.hasActiveSoftIntegration) {
        const activesoftIntegrationOfUser =
          (await this.activesoftIntegrationService
            .getByIdUser(this.user.id)
            .toPromise()) as ActivesoftIntegration;
        if (activesoftIntegrationOfUser) {
          this.userForm
            .get('idActivesoft')
            ?.setValue(
              this.activesoftIntegrationUtil.idActivesoftWithoutPrefix(
                activesoftIntegrationOfUser.idIntegration
              )
            );
        }
      }
    }
  }

  private populateUser(): User {
    var nameArr = this.userForm.value.name.trim().split(/\s+/);
    var firstN =
      nameArr && nameArr.length > 1
        ? nameArr.slice(0, -1).join(' ')
        : nameArr.pop();
    var photoData = this.user?.photo;
    let user: User = {
      idsSchool: this.idsSchool,
      id: '',
      active: true,
      email: this.userForm.value.email,
      password: this.userForm.value.password,
      idsProfiles: [this.userForm.value.profile.id],
      firstName: firstN,
      lastName: nameArr && nameArr.length > 1 ? nameArr.pop() : ' ',
      dtCreated: new Date(),
      photo: photoData
        ? photoData
        : `https://ui-avatars.com/api/?size=512&name=${firstN}`,
      phone: this.userForm.value.phone
        ? this.userForm.value.phone
        : '00000-0000',
    };

    return user;
  }

  private resetView() {
    this.userForm.reset();
    this.showBasicFields = false;
    this.showStudentElements = false;
    this.isResponsible = false;
    this.resetPasswordValidator();
  }

  private createTreeSegments() {
    const classroomFilter: ClassroomFilterDto = {
      idSchool: this.idsSchool![0],
    };
    this.treeSegmentsService
      .createTreeNoRoot(this.classRoomsFromChild, false, classroomFilter)
      .subscribe((treeNode) => {
        this.treeSegments = treeNode;
        if (this.treeSegments) {
          this.formatSelectedSegmentsTexts();
        }
      });
  }

  private formatSelectedSegmentsTexts() {
    if (this.treeSegments) {
      this.treeSegmentsSelected = this.treeSegmentsService.hasCheckedItems(
        this.treeSegments
      );
      if (this.treeSegmentsSelected) {
        this.segmentsSelectedText =
          this.treeSegmentsService.formatSelectedsText(this.treeSegments!);
      } else {
        this.segmentsSelectedText = '';
        this.segmentsSelectedText = this.segmentsSelectedText;

        if (this.segmentsSelectedText == '')
          this.segmentsSelectedText = this.segmentsDefaultText;
      }
    }
  }

  handleHelp() {
    if (this.userForm.get('profile')?.value) {
      this.dialog.open(HelpUserProfilesDialogComponent, {
        width: '345px',
        panelClass: 'help-container',
        data: this.userForm.get('profile')?.value,
      });
    }
  }

  handleHelpIdActivesoft() {
    let helpDialog = {
      title: `O código deve seguir o formato padrão: ${this.prefixIdActivesoft} seguido da numeração`,
      message: `Exemplo: ${this.prefixIdActivesoft}1234`,
    } as HelpDialog;
    this.dialog.open(HelpDialogComponent, {
      width: '345px',
      panelClass: 'help-container',
      data: helpDialog,
    });
  }

  idActivesoftFocus = false;

  showPrefix() {
    return this.userForm.value.idActivesoft !== '';
  }

  async changeUser(id: string): Promise<void> {
    let user = await this.userService.getById(id).toPromise();
    this.selectedUser.setSelectedUser(user);

    await genericDialog(
      this.dialog,
      this.dialogInfo,
      'custom-dialog-confirmation'
    ).subscribe((confirmed) => {
      if (confirmed) this.ngOnInit();
    });
  }

  private invalidateMinimumPassword(min: number) {
    this.userForm.controls['password'].setValidators([
      Validators.required,
      Validators.minLength(min),
    ]);
    this.userForm.controls['password'].updateValueAndValidity();
    this.invalidMinPasswordErrorMessage = `Senha deve conter ao menos ${min} caracteres`;
  }

  private resetPasswordValidator() {
    this.userForm.controls['password'].setValidators([Validators.required]);
    this.invalidMinPasswordErrorMessage = undefined;
  }

  private handleError(error: any, status: string) {
    const erroMessage = this.formatEmailExistErroMessage(error);
    if (erroMessage) {
      this.userForm.get('email')?.setErrors({ emailExists: true });
      this.openSnackbar('warn', erroMessage);
    } else {
      this.openSnackbar(status);
    }
  }
}
